import { useState } from 'react';
import {
  RxHamburgerMenu,
} from 'react-icons/rx';
import {
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  IconButton,
  Avatar,
} from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { useDispatch, useSelector } from 'react-redux';
import {
  FiHome, FiClipboard, FiUserPlus, FiHelpCircle,
} from 'react-icons/fi';
import getSubdomain from '../utils/getSubdomain';
import config from '../config/config';
import { auth } from '../config/firebase-config';
import { logout, RootState } from '../store';
import ThemeToggle from './ThemeToggle';
import AvanttiIcon from './icons/AvanttiIcon';
import Ticket from './icons/Ticket';
import AvanttiLogo from './icons/AvanttiLogo';
import { UserType } from '../models/user';

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { user } = useSelector((state: RootState) => state.auth);
  const [open, setOpen] = useState(true);
  console.log(user);

  const items = [
    ...(user.type === UserType.ROOT ? [{
      name: 'Panel de control',
      icon: <FiHome className='w-7 h-7' />,
      url: '/admin',
    },
    ] : []),
    ...(user.user_events?.length >= 1 ? [{
      name: 'Eventos',
      icon: <Ticket className='w-7 h-7' />,
      url: '/admin/all-events',
    }] : []),
    {
      name: 'Productoras',
      icon: <FiClipboard className='w-7 h-7' />,
      url: '/admin/businesses',
    },
    {
      name: 'Invitaciones',
      icon: <FiUserPlus className='w-7 h-7' />,
      url: '/admin/invitations',
    },
  ];

  const select = (url: string) => {
    if (getSubdomain()) {
      window.location.href = `${config.baseDomain}${url}`;
    } else {
      navigate(url);
    }
  };
  const handleLogout = () => {
    signOut(auth)
      .then(() => {
        dispatch(logout());
      })
      .catch((error) => {
        console.error(error);
      });
  };
  const handleClickHelp = () => {
    window.open('https://wa.me/message/GV2TPBX7VGT5A1', '_blank');
  };
  return (
    <div>
      <Drawer variant="permanent" open={open} sx={{
        width: open ? 280 : 80,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: open ? 280 : 72,
          transition: 'width 0.3s',
          overflowX: 'hidden',
          maxHeight: '100vh',
          borderRight: '1px solid rgb(var(--color-border-secondary))',
          color: 'rgb(var(--color-text-primary))',
          backgroundColor: 'rgb(var(--color-surface-base) / 0.5)',
          backdropFilter: 'blur(16px)',
          '-webkit-backdrop-filter': 'blur(16px)',
          padding: '4px',
        },
      }}>
        <div className='flex flex-col justify-between h-full'>
          <div>
            <div>
              {open ? (
                <div className='flex flex-col'>
                  <div className='flex flex-row pt-8 pl-2 pb-6 mx-auto items-center gap-4'>
                    <div className='flex flex-col'>
                      <AvanttiIcon className='text-text-primary' />
                      <span className='text-lg text-text-primary font-medium ml-auto'>
                        BACKOFFICE
                      </span>
                    </div>
                    <div className='w-fit mb-2.5'>
                      <ThemeToggle />
                    </div>
                  </div>
                  {/* <div className='px-4 pb-2'>
                    <Input
                      id="search-event"
                      label="Buscar"
                      placeholder="Buscar"
                      isSearch
                    /></div> */}
                </div>
              ) : (
                <div className='my-4 ml-0.5 hover:rounded-none'>
                  <IconButton onClick={() => setOpen(!open)} className="w-full" sx={{
                    borderRadius: '0px',
                    color: 'rgb(var(--color-text-primary))',
                    '&:hover': {
                      borderRadius: '0px',
                      backgroundColor: 'rgb(var(--color-surface-base) / 0.5)',
                      backdropFilter: 'blur(16px)',
                      '-webkit-backdrop-filter': 'blur(16px)',
                    },
                  }}>
                    <RxHamburgerMenu className='hover:rounded-none' />
                  </IconButton></div>
              )}
            </div>
            <List className='flex flex-col gap-4' sx={{
              '& .MuiListItem-root': {
                '&:hover': {
                  backgroundColor: 'rgb(var(--color-surface-tertiary) / 0.5)',
                  backdropFilter: 'blur(16px)',
                  '-webkit-backdrop-filter': 'blur(16px)',
                },
              },
            }}>
              {items.map((item, index) => {
                const { pathname } = location;
                // Exclude known admin paths to correctly identify business IDs
                const businessIdPattern = /^\/admin\/(?!(onboarding|map-creator|avantti-report|superadmin|dashboard|businesses|all-events|invitations|create-business|order-success|order-error)(\/|$))[a-zA-Z0-9-]+/;
                const eventIdPattern = /^\/admin\/[a-zA-Z0-9-]+\/events\/[a-zA-Z0-9-]+/;

                let isSelected = false;

                switch (item.name) {
                  case 'Panel de control':
                    isSelected = pathname === '/admin' || pathname === '/admin/dashboard' || pathname === '/admin/';
                    break;
                  case 'Productoras':
                    isSelected = pathname.startsWith('/admin/businesses') || (businessIdPattern.test(pathname) && !eventIdPattern.test(pathname));
                    break;
                  case 'Eventos':
                    isSelected = pathname.startsWith('/admin/all-events') || eventIdPattern.test(pathname);
                    break;
                  default:
                    // For 'Invitaciones' and other items
                    isSelected = pathname.startsWith(item.url);
                }

                return (
                  <ListItem key={index} onClick={() => { select(item.url); }} className={
                    `cursor-pointer rounded-3xl p-8 ${isSelected ? 'bg-surface-secondary bg-gradient-brand text-white' : ''} ${index === 3 ? 'ml-1' : ''}`}>
                    <ListItemIcon><div className={`flex pl-3 justify-center items-center ${isSelected ? 'text-white font-medium' : 'text-primary-500'}`}>{item.icon}</div></ListItemIcon>
                    {open && <div className='text-md text-text-white'>{item.name}</div>}
                  </ListItem>
                );
              })}
            </List>
          </div>
          <div>
            <List className='flex flex-col gap-4' sx={{
              '& .MuiListItem-root': {
                '&:hover': {
                  backgroundColor: 'rgb(var(--color-surface-tertiary))',
                  backdropFilter: 'blur(16px)',
                  '-webkit-backdrop-filter': 'blur(16px)',
                },
              },
            }}>
              <div className='flex flex-col gap-4 mb-10'>
                <ListItem className='cursor-pointer rounded-3xl' onClick={() => navigate('/')}>
                  <ListItemIcon>
                    <div className='pl-2.5 text-primary-500'>
                      <AvanttiLogo className='w-7 h-7' />
                    </div>
                  </ListItemIcon>
                  {open && <div className='text-md text-text-primary'>Plataforma Avantti</div>}
                </ListItem>

                <ListItem className='cursor-pointer rounded-3xl' onClick={handleClickHelp}>
                  <ListItemIcon>
                    <div className='pl-2.5 text-primary-500'>
                      <FiHelpCircle className='w-7 h-7' />
                    </div>
                  </ListItemIcon>
                  {open && <div className='text-md text-text-primary'>Centro de ayuda</div>}
                </ListItem>
              </div>

              <div className='flex flex-col gap-4 border-t border-border-secondary pt-3 pb-2 bg-blur-lg bg-opacity-sm m-[-4px] mb-[-12px]'>
                <ListItem className='cursor-pointer rounded-3xl'>
                  <ListItemIcon className='pl-1'>
                    <Avatar
                      src={user.photo_url || ''}
                      className='w-12 h-12 '
                      sx={{
                        backgroundColor: 'rgb(var(--color-surface-secondary))',
                        color: 'rgb(var(--color-text-primary))',
                      }}
                    />
                  </ListItemIcon>
                  {open && <div className='flex flex-col'>
                    <div className='text-md text-text-primary'>{user.username}</div>
                    <div
                      className="text-sm text-text-secondary max-w-[250px] truncate"
                      title={user.email}
                    >
                      {user.email}
                    </div>
                  </div>}
                </ListItem>
                <ListItem className='cursor-pointer rounded-3xl' onClick={handleLogout}>
                  <div className='pl-1 pt-2'>
                    <ListItemIcon>
                      <div className='bg-surface-secondary rounded-3xl p-2.5'>
                        <img src='/log-out.svg' alt="icon" />
                      </div>
                    </ListItemIcon>
                  </div>
                  {open && <div className='text-md text-text-primary'>Cerrar sesión</div>}
                </ListItem>
              </div>
            </List>
          </div>
        </div>
      </Drawer>
    </div>
  );
};

export default Sidebar;
